"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContainer = void 0;
var react_1 = __importStar(require("react"));
var utils_1 = require("@qwilr/kaleidoscope/utils");
var react_dom_1 = require("react-dom");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var classnames_1 = __importDefault(require("classnames"));
var utils_2 = require("@qwilr/kaleidoscope/utils");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var Types_1 = require("./Types");
var styles = __importStar(require("./ModalContainer.css"));
var focus_trap_react_1 = __importDefault(require("focus-trap-react"));
var ModalContainer = function (_a) {
    var show = _a.show, onDismiss = _a.onDismiss, children = _a.children, _b = _a.escapeKeyClose, escapeKeyClose = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? Types_1.modalRootId : _c, _d = _a.theme, theme = _d === void 0 ? tokens_1.lightTheme : _d, onEnter = _a.onEnter;
    var root = (0, utils_1.getPortalRoot)(rootId);
    var previousFocusedElement = (0, react_1.useRef)(null);
    var _e = __read((0, react_1.useState)(show), 2), showModal = _e[0], setShowModal = _e[1];
    (0, react_1.useEffect)(function () {
        if (!showModal) {
            return;
        }
        var handler = function (ev) {
            if (ev.key === kaleidoscope_1.KeyType.Escape) {
                if (escapeKeyClose) {
                    onDismiss();
                }
            }
        };
        document.addEventListener("keydown", handler);
        return function () {
            document.removeEventListener("keydown", handler);
        };
    }, [showModal, onDismiss, escapeKeyClose]);
    (0, react_1.useEffect)(function () {
        if (show) {
            if (document.activeElement) {
                previousFocusedElement.current = document.activeElement;
            }
            setShowModal(true);
        }
        else {
            setShowModal(false);
            var element = previousFocusedElement.current;
            element === null || element === void 0 ? void 0 : element.focus();
            previousFocusedElement.current = null;
        }
    }, [show]);
    var suppressMouseInteraction = function (e) {
        e.stopPropagation();
    };
    if (!root) {
        return null;
    }
    return (0, react_dom_1.createPortal)(react_1.default.createElement(react_transition_group_1.Transition, { in: showModal, timeout: kaleidoscope_2.AnimationDuration.Long, mountOnEnter: true, unmountOnExit: true, onEnter: function (node) {
            (0, utils_2.forceReflow)(node);
            onEnter === null || onEnter === void 0 ? void 0 : onEnter(node);
        } }, function (status) { return (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.container, styles.transition({ status: status }), theme), onClick: onDismiss, onMouseDown: suppressMouseInteraction },
        react_1.default.createElement(focus_trap_react_1.default, { focusTrapOptions: { clickOutsideDeactivates: true } },
            react_1.default.createElement("div", { className: styles.content({ status: status }), onClick: suppressMouseInteraction, "aria-modal": "true" }, children)))); }), root);
};
exports.ModalContainer = ModalContainer;
